import { cva } from "class-variance-authority";

import { Spinner } from "../Spinner";

const button = cva(["btn", "btn-primary", "relative"], {
  variants: {
    size: {
      xs: "btn-xs",
      sm: "btn-sm",
      md: "btn",
      lg: "btn-lg",
    },
    variant: {
      primary: "btn-primary",
      secondary: "btn-secondary",
      clear: "btn-clear",
      light: "btn-light",
      outline: "btn-outline",
      none: "",
    },
    property: {
      success: "btn-success",
      danger: "btn-danger",
      info: "btn-info",
      warning: "btn-warning",
    },
    icon: {
      true: "btn-icon",
    },
    block: {
      true: "flex justify-center grow",
    },
    color: {
      none: "",
      green: "bg-[#296573]",
      red: "bg-[#8D4F61]",
      yellow: "bg-[#F2C57C] hover:bg-[#F2C57C]",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  size?: "xs" | "sm" | "md" | "lg";
  variant?: "primary" | "secondary" | "clear" | "light" | "outline";
  property?: "success" | "danger" | "info" | "warning";
  color?: "none" | "green" | "red";
  icon?: boolean;
  block?: boolean;
  loading?: boolean;
}

export function Button({
  size = "md",
  variant = "primary",
  property,
  icon = false,
  block = false,
  loading = false,
  className,
  disabled,
  children,
  color = "none",
  ...props
}: ButtonProps) {
  return (
    <button
      disabled={loading || disabled}
      className={button({
        size,
        variant,
        icon,
        block,
        property,
        className,
        color,
      })}
      {...props}
    >
      <div
        className={`flex items-center gap-2 justify-center ${loading ? "opacity-0" : "opacity-100"}`}
      >
        {children}
      </div>
      {loading && (
        <div className="absolute left-0 right-0 top-0 bottom-0 flex flex-1 w-full h-full items-center justify-center">
          <Spinner />
        </div>
      )}
    </button>
  );
}
